import { useLayoutEffect, useState, type RefObject } from 'react';

export interface Size { width: number; height: number }

/**
 * Border-box layout size of an element (its own CSS px: under CSS zoom, what its contents lay out in), kept
 * current with a ResizeObserver (null until first measured).
 */
export function useElementSize(ref: RefObject<HTMLElement | null>, enabled = true) {
  const [size, setSize] = useState<Size | null>(null);
  useLayoutEffect(() => {
    const el = ref.current;
    if (!el || !enabled) {
      setSize(null);
      return;
    }
    const measure = () => {
      const r = { width: el.offsetWidth, height: el.offsetHeight };
      setSize((s) => (s && s.width === r.width && s.height === r.height ? s : r));
    };
    measure();
    const ro = new ResizeObserver(measure);
    ro.observe(el);
    return () => ro.disconnect();
  }, [ref, enabled]);
  return size;
}
